module.exports = __webpack_public_path__ + "img/visit-download-icon.4f0f0978.svg";